import React from "react";

function UserSettingsTab(props) {
  return <div>Users & permissions (under construction...)</div>;
}

export default UserSettingsTab;
